import React, { PropsWithChildren } from "react";
import { useMergedItem } from "./UseMergedItem";
import { MergeContext } from "./MergeContext";

export function MergeContextProvider(props: PropsWithChildren<unknown>): JSX.Element {
  const { children } = props;
  return <MergeContext.Provider value={useMergedItem()}>{children}</MergeContext.Provider>;
}
